<template>
  <validation-observer v-slot="{ invalid }" ref="RMstep1">
  <b-form @submit.prevent="addRawMaterial" @change="submitForm()">
    <b-row>
      <b-col md="6">
        <b-form-group label="Raw Material Name" label-for="mc-Raw Material-name">
          <validation-provider
          #default="{errors}"
          name="Raw Material Name"
          rules="required"
          >
          <b-form-input type="text" id="mc-Raw Material-name" placeholder="Raw Material Name" v-model="form.name" required />
          <!--<span v-if="!name" class="text-danger" >Material name is required</span>-->
          <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      
      </b-col>

      <b-col md="6">
        <b-form-group label="Raw Material Code" label-for="mc-Raw Material-Code">
          <b-form-input type="text" id="mc-Raw Material-Code" placeholder="Raw Material Code" v-model="form.code" />
        </b-form-group>
      </b-col>


      <b-col md="6">
        <b-form-group label-for="mc-stock-threshold" label="Low Stock Threshold">
          <validation-provider
          #default="{errors}"
          name="Low Stock Threshold"
          vid="code"
          rules="required"
          >
            <b-form-input id="mc-stock" type="number" placeholder="Low Stock Threshold" v-model="form.lowStock"
                    @keypress="allowOnlyNumbers($event)"
                    @wheel="allowOnlyNumbers($event)" required />
            <!--<span v-if="!lowStock" class="text-danger" >Low Stock Threshold is required</span>-->
            <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      
      <b-col md="6">
        <b-form-group label-for="mc-stock-threshold" label="Unit of Measure (UOM)">
          <b-form-select v-model="form.defaultUomID" :options="itemUoms" value-field="id" text-field="name" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Price (Rs)" label-for="Price">
          <b-form-input type="number" id="mc-Raw Material-Price" placeholder="Raw Material Price"
                    @keypress="allowOnlyNumbers($event)"
                    @wheel="allowOnlyNumbers($event)"
            v-model="form.purchasePrice" />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Category" label-for="mc-Category">
          <validation-provider
          #default="{errors}"
          name="Category"
          rules="required"
          >
          <b-form-select v-model="form.categoryID" :options="parentCategoryList"
           value-field="id"
            @change="fetchCategoryDetails(form.categoryID)"
            text-field="name" required />
          <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Preferred Supplier" label-for="mc-Supplier">
          <b-form-select v-model="form.supplierId" :options="suppliers" value-field="id" text-field="name" />
        </b-form-group>
      </b-col>
        <b-col cols="6">
          <b-form-group
            :disabled="form.categoryID != null"
            label="Sub Category"
            label-for="mc-subCategory"
          >
            <b-form-select
              v-model="form.ProductCategorySubId"
              :options="subCategoryList"
              value-field="id"
              text-field="name"
            />
          </b-form-group>
        </b-col>
      <b-col cols="12" class="mb-2">
        <label for="textarea-default">Raw Material Description</label>
        <b-form-textarea id="textarea-default" placeholder="Raw Material Description" rows="5"
          v-model="form.description" />
      </b-col>
    </b-row>

    <CustomFieldsDetails
        :AdditionalFields="form.additionalFields"
        :ModuleReference="'RawMaterial'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
  </b-form>
</validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";

import lowstock from "@/router/routes/inventory/lowstock";
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import { fnSortingDropdown, customError, customSwal, allowOnlyNumbers } from "@/libs/customFn";

export default {
  name: "AddRawMaterial",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    required,
    FormWizard, TabContent,
    CustomFieldsDetails,
    fnSortingDropdown,
  },
  data() {
    return {
      form: {
      name: "",
      description: null,
      categoryID: null,
      code: "",
      supplierId: null,
      lowStock: "",
      defaultUomID: null,
      purchasePrice: 0,
      additionalFields: [
        {
          fieldName: null,
          fieldValue: null,
          fieldType: "text",
          isRequired: false,
          displayEcomm: false,
        },
      ],
       productCategorySubId: null,
      },
      parentCategoryList: [],
      subCategoryList: [],
    };
  },
  methods: {
    async fetchCategoryDetails(id) {
      console.log("🚀 ~ fetchCategoryDetails ~ id:", id)
      this.subCategoryList = await this.getItemSubCategoryListAction(id);

    },
    async formValidation(){
      let stepValidation = await this.$refs.RMstep1.validate();
      this.$refs.RMstep1.validate().then((stepValidation) => {
        if (!stepValidation) {
          // Find the first invalid field
          const firstErrorField = this.$el.querySelector('.text-danger');
          if (firstErrorField) {
            // Scroll to the first invalid field
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: "end", inline: "nearest"  });
            // Set focus on the first invalid field
            firstErrorField.focus();
          }
        }
      });
      return stepValidation;
    },
    setSubCategory() {
      this.subCategoryList = this.rawitemCategories.filter(
        (x) => x.isSub && x.parentId == this.form.categoryID
      );
      this.subCategoryList = fnSortingDropdown(
        this.subCategoryList,
        "asc",
        "name"
      );
    },
    submitForm() {
      this.$emit("onchange", this.form);
      console.log("Form data:", this.form);
      this.$emit('formUpdate', this.form);
    },

    additionalFieldChanges(customFields) {
      this.form.additionalFields = customFields;
    },
    success() {
      this.$swal({
        title: "Raw Material Added!",
        text: "You have successfully added the raw material!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: "rawmaterials-list" });
        }
      });
    },  
    // error
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data.request);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    ...mapActions("rawmaterialModule", ["addRawMaterialAction"]),
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("itemcategoryModule", ["getItemCategoryListAction", "getItemCategoryAction", "getItemSubCategoryListAction"]),
    ...mapActions("supplierModule", [
      "getSupplierListAction"
    ]),
    // addRawMaterial() {
    //   this.$refs.RawMaterials.validate().then((success) => {
    //     if (success) {
    //   let payload = {
    //     name: this.name,
    //     description: this.description,
    //     categoryID: this.categoryID,
    //     code: this.code,
    //     supplierId: this.supplierId,
    //     lowStock: this.lowStock,
    //     defaultUomID: this.defaultUomID,
    //     purchasePrice: this.purchasePrice,
    //     additionalFields: this.form.additionalFields,
    //   };

    //   console.log("Payload before sending:", payload);
    //   this.addRawMaterialAction(payload)
    //     .then(() => {
    //       this.success();
    //     })
    //     .catch((error) => {
    //       this.error(error.response.data);
    //     });
    //   }
    //   })
    // },
  },
  computed: {
    ...mapGetters("itemUomModule", {
      rawItemUoms: "itemuom",
      loading: "loading",
    }),
    itemUoms() {
    return this.rawItemUoms.slice().sort((a, b) => a.name.localeCompare(b.name));
  },
    ...mapGetters("itemcategoryModule", {
      rawitemCategories: "itemcategories",
      loading: "loading",
    }),
  //   itemCategories() {
  //   return this.rawitemCategories.slice().sort((a, b) => a.name.localeCompare(b.name));
  // },
    ...mapGetters("rawmaterialModule", {
      loading: "loading",
    }),
    ...mapGetters("supplierModule", {            
            rawsuppliers: "suppliers",
            loading: "loading"
        }),
        suppliers() {
    return this.rawsuppliers.slice().sort((a, b) => a.name.localeCompare(b.name));
  },
  },
  async mounted() {
    await this.getItemUOMListAction();
    await this.getItemCategoryListAction();

    this.parentCategoryList = fnSortingDropdown(
      this.rawitemCategories.filter((x) => !x.isSub),
      "asc",
      "name"
    );
    await this.getSupplierListAction();
  },
  setup(){
    return {
      allowOnlyNumbers
    }
  }
};
</script>
